import raw from "./globals.css?inline"

/** Injected into `document.head` by the UMD entry (no separate CSS file). */
export const hostWidgetCss = raw

/** Injected into Shadow DOM (`:root` → `:host`). */
export const shadowWidgetCss = raw.replace(/:root/g, ":host")
